var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"tooltip-container"},[_c('div',{class:[_vm.arrowPositionClass.position, _vm.arrowPositionClass.direction]},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }